import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
///import { getToken, removeToken, getUserId, getUuid } from "@/utils/auth";
var appid = "tiku20210821";
// create an axios instance
const service = axios.create({
    // baseURL: 'http://192.168.1.88:8101/index.php/api', // url = base url + request url
    // baseURL: 'https://tiku.chexuetang.cn/api', // url = base url + request url
    
    // baseURL: 'http://tikuapi.chexuetang.cn/api/',
    baseURL: 'http://tikuapi.chexuetang.cn/',
    
    // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 500000 // request timeout
});
console.log(service.interceptors.request)

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        config.headers["signtype"] = "tiku";
       // config.headers["appid"] = appid;
        //config.headers["Content-Type"] = appid;
       /* var token = localStorage.getItem('h5_usertoken') || store.getters.token;
        if (token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers["usertoken"] = '2457c5bec132f56950517b3a00793e76';
            config.headers["userid"] = 8;
            config.headers["appid"] = localStorage.getItem('h5_appid');;
           
           // config.headers["provinceid"] =320000;;
       }*/
        return config;
    },
    error => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;

        // if the custom code is not 20000, it is judged as an error.
        if (response.status !== 200 || res.code === 50008) {
            Message({
                message: res.message || "Error",
                type: "error",
                duration: 5 * 100000
            });

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 50008) {
                // to re-login
                MessageBox.confirm("您没有登录，请登录后再访问", "登录提示", {
                    confirmButtonText: "重新登录",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                   // removeToken();
                    location.href = "/studytime";
                });
            }
            // return Promise.reject(new Error(res.message || 'Error'))
        } else {
            if (res.code === 403) {
                Message({
                    message: res.message || "Error",
                    type: "warning",
                    duration: 5 * 100000
                });
            }
            return res;
        }
    },
    error => {
        console.log("err" + error); // for debug
        Message({
            message: error.message,
            type: "error",
            duration: 3 * 1000
        });
        return Promise.reject(error);
    }
);

export default service;
